import { render, staticRenderFns } from "./RecomOrder.vue?vue&type=template&id=ccfe6faa"
import script from "./RecomOrder.vue?vue&type=script&lang=js"
export * from "./RecomOrder.vue?vue&type=script&lang=js"
import style0 from "./RecomOrder.vue?vue&type=style&index=0&id=ccfe6faa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports